import clsx from 'clsx'
import { Col, Grid, Icon, Popover, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AddCardDropdown } from 'modules/Statistics/Pulse/components/AddCardDropdown'
import styles from 'modules/Statistics/Pulse/components/AddCard/AddCard.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useDispatch } from 'react-redux'
import { PULSE_SET_NEW_METRICS } from 'modules/Statistics/types'

export const AddCard = ({ className = '', metrics = {} }) => {
  const { bindPopover, usePopupState, bindTrigger } = Popover.usePopover()
  const { t } = useTranslation(['pulse'])
  const breakpoints = useBreakpoint()
  const dispatch = useDispatch()

  const popoverState = usePopupState({
    id: 'add-metrics-selector-popover',
  })

  return (
    <Col
      s={12}
      sm={6}
      fb={6}
      md={6}
      lg={4}
      xl={3}
      className={clsx(styles['add-card'], className, {
        [styles['add-card_hidden']]: Object.entries(metrics).length === 0,
      })}
    >
      <a className={styles['add-card__button']}>
        <div className={styles['add-card__content']}>
          <Grid
            className={styles['add-card__button-wrapper']}
            gap={16}
            direction={'column'}
            alignItems={'center'}
            justifyContent={'center'}
            {...bindTrigger(popoverState)}
          >
            <div className={styles['add-card__button-icon']}>
              <Icon
                name="plus"
                size={'m'}
                width={!breakpoints.fb && 20}
                color={'Interface-Eighth'}
              />
            </div>
            <Typography
              noMargin
              variant={'Body-20'}
              color={'Interface-Eleven'}
              className={styles['add-card__button-text']}
            >
              {t('chart.add_metric')}
            </Typography>
          </Grid>
        </div>
      </a>

      <Popover
        disablePortal={true}
        bodyClassName={styles['popover-dropdown-inner']}
        {...bindPopover(popoverState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        breakpoints={{
          0: {
            showLabel: true,
            label: t('chart.add_metric'),
            variant: 'bottomSheet',
            hasBackdrop: true,
          },
          768: {
            showLabel: true,
            label: t('chart.add_metric'),
            variant: 'popover',
            hasBackdrop: false,
          },
        }}
      >
        <AddCardDropdown
          className={styles['add-card__dropdown']}
          metrics={metrics}
          onSelect={(metrics) => {
            popoverState.close()
            dispatch({ type: PULSE_SET_NEW_METRICS, payload: { metrics } })
          }}
        />
      </Popover>
    </Col>
  )
}

AddCard.defaultProps = {
  className: '',
  metrics: {},
  hidden: true,
}

AddCard.propTypes = {
  className: PropTypes.string,
  metrics: PropTypes.object,
  hidden: PropTypes.bool,
}
